// import MUI - React
import { Alert, Box, Snackbar, Typography, } from "@mui/material";
// Icons
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined';

const CustomSnackbar = ({ open, message, type, onClose  }) => {

    function icons() {
        switch (type) {
            case "success":
                return
            case "info":
                return <ReportOutlinedIcon />
            case "warning":
                return
            case "error":
                return <InfoOutlinedIcon />
            default:
                break;
        }

    }
    return (
        <Snackbar open={open} autoHideDuration={3000} onClose={onClose} >
            <Alert variant="filled" severity={type} onClose={onClose} sx={{ width: '100%' }}>
                <Box display={"flex"}>
                    {icons()}
                    <Typography>{message}</Typography>
                </Box>
                </Alert>
        </Snackbar>);
}
export default CustomSnackbar;